export default {
  "component.tagSelect.expand": "展開",
  "component.tagSelect.collapse": "收起",
  "component.tagSelect.all": "全部",
};
